import React from 'react';

// tslint:disable max-line-length
const CLetThemKnowPart1TranscriptMunch: React.FC = () => (
  <>
    <h5>Record a message for part 1</h5>
    <p>They say it’s the thought that counts. Sure, it’s a cliché but it’s true, right? I want to ask you to speak to this person. Let them hear your voice. Talk to them as if you were leaving a voicemail. You’re not disturbing anyone. Take your time to think, and tap the button when you’re ready.</p>
  </>
);

export {
  CLetThemKnowPart1TranscriptMunch,
};
